import {Flex, Square, Text} from '@chakra-ui/react';
import {FC} from 'react';
import LinkUI from 'ui/LinkUI';
import NextImageUI from 'ui/NextImage';

interface Props {
  name?: string;
  img?: string;
  size?: string;
  slug?: string;
  isMetro?: boolean;
}

export const ProviderLogo: FC<Props> = ({name, img, size = '100px', slug, isMetro}) => {
  const link = isMetro ? `/${slug}` : `/restaurant/${slug}`;
  const sizeNum = parseInt(size.split('px')[0], 10);
  return (
    <LinkUI href={link}>
      <Flex direction="column" alignItems="center">
        <Square
          size={size}
          borderRadius="16px"
          overflow="hidden"
          boxShadow="2px 3px 10px rgba(151, 151, 151, 0.3);"
          bg="white"
        >
          {img && (
            <NextImageUI
              src={img}
              alt={slug || 'Provider logo'}
              width={sizeNum}
              height={sizeNum}
              style={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          )}
        </Square>
        {name && (
          <Text noOfLines={2} fontSize="16px" fontWeight={600} mt="15px" w="100px" textAlign="center">
            {name}
          </Text>
        )}
      </Flex>
    </LinkUI>
  );
};
